<template>
  <div v-if="conciliacaoLotes.length === 0">
    Nenhum lote de faturamento encontrado.
  </div>
  <v-list v-else flat>
    <v-list-item
      v-for="conciliacaoLote in conciliacaoLotes"
      :key="conciliacaoLote.faturamentoLoteId"
      class="px-0"
    >
      <v-list-item-content class="pt-0">
        <pagamento-baixa-faturamento-lote-baixado-card
          v-on="$listeners"
          :faturamentoLoteBaixado="conciliacaoLote"
          :isSelected="isSelected(conciliacaoLote.faturamentoLoteId)"
          :isAssociado="faturamentoLoteIdsAssociados.has(conciliacaoLote.faturamentoLoteId)"
        />
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import PagamentoBaixaFaturamentoLoteBaixadoCard from './PagamentoBaixaFaturamentoLoteBaixadoCard.vue'

export default {
  components: {
    PagamentoBaixaFaturamentoLoteBaixadoCard
  },
  props: {
    selectedConciliacaoLotes: Array,
    conciliacaoLotes: Array
  },
  computed: {
    faturamentoLoteIdsAssociados () {
      return new Map(
        this.conciliacaoLotes.map(conciliacaoLote => [
          conciliacaoLote.faturamentoLoteId,
          conciliacaoLote.id
        ])
      )
    }
  },
  methods: {
    isSelected (faturamentoLoteId) {
      return this.selectedConciliacaoLotes.some(lote => lote.faturamentoLoteId === faturamentoLoteId)
    }
  }
}
</script>
